import letterTemplateReducer from "./letterTemplateReducer";

const letterTemplateReducers = {
    letterTemplate: letterTemplateReducer
}

export default letterTemplateReducers;